// Share in-flight requests across widget, search, logo, and room consumers.
export class RequestCache {
  constructor() { this.entries = new Map(); }
  get(key, load, ttl = 3000) {
    const previous = this.entries.get(key);
    if (previous && (previous.pending || previous.expires > Date.now())) return previous.promise;
    const entry = { pending: true, expires: 0 };
    entry.promise = Promise.resolve().then(load).then(value => {
      entry.pending = false;
      entry.expires = Date.now() + ttl;
      return value;
    }, error => {
      if (this.entries.get(key) === entry) this.entries.delete(key);
      throw error;
    });
    this.entries.set(key, entry);
    // Bound caches even when users try many different searches.
    if (this.entries.size > 100) {
      for (const [oldKey, oldEntry] of this.entries) {
        if (!oldEntry.pending && oldEntry.expires <= Date.now()) this.entries.delete(oldKey);
      }
    }
    return entry.promise;
  }
  clear() { this.entries.clear(); }
  invalidate(key) {
    if (!this.entries.get(key)?.pending) this.entries.delete(key);
  }
}
